import {
  readWorkspaceAgentPillNodeAttrs,
  WORKSPACE_AGENT_PILL_NODE_NAME,
} from '~/components/v2/components/workspace/workspace-agent-panel/tiptap/workspaceAgentPill';
import {
  readWorkspaceAgentSkillMonikerAttrs,
  WORKSPACE_AGENT_SKILL_MONIKER_NODE_NAME,
} from '~/components/v2/components/workspace/workspace-agent-panel/tiptap/workspaceAgentSkillMoniker';
import {
  buildWorkspaceAgentComposerNodePill,
  type WorkspaceAgentComposerDoc,
  type WorkspaceAgentComposerSerializeOptions,
} from '~/components/v2/components/workspace/workspace-agent-panel/utils/serializeWorkspaceAgentComposerContent';

/** A pill the serializer would emit — same builder, so the two cannot drift apart. */
const isSendableWorkspaceAgentPillNode = (attrs: Record<string, unknown>): boolean => {
  const pillAttrs = readWorkspaceAgentPillNodeAttrs(attrs);

  return !!pillAttrs && !!buildWorkspaceAgentComposerNodePill(pillAttrs);
};

/**
 * Non-whitespace text or a sendable inline pill. Runs per keystroke, so it doesn't go through the
 * serializer, which reports malformed pills to Bugsnag — but it asks the serializer's own builder, so
 * a node the serializer would drop cannot make an otherwise empty composer sendable.
 */
export const hasSendableWorkspaceAgentComposerContent = (
  editor: WorkspaceAgentComposerDoc,
  options?: WorkspaceAgentComposerSerializeOptions,
): boolean => {
  let isSendable = false;

  editor.state.doc.descendants((node) => {
    if (isSendable) {
      return false;
    }

    const isSendablePill =
      node.type.name === WORKSPACE_AGENT_PILL_NODE_NAME && isSendableWorkspaceAgentPillNode(node.attrs);
    const skillAttrs =
      node.type.name === WORKSPACE_AGENT_SKILL_MONIKER_NODE_NAME
        ? readWorkspaceAgentSkillMonikerAttrs(node.attrs)
        : null;
    const isSendableSkillMoniker = !!skillAttrs && !!options?.resolveSkill?.(skillAttrs.skillId);

    if (isSendablePill || isSendableSkillMoniker || (node.isText && node.text?.trim())) {
      isSendable = true;

      return false;
    }

    return true;
  });

  return isSendable;
};
